export async function fetchValidated<T>(url: string, schema: { parse: (value: unknown) => T }): Promise<T> {
  const response = await fetch(url, {
    cache: "no-store",
    headers: { Accept: "application/json" },
  });
  if (!response.ok) throw new Error(`${url}: ${response.status}`);
  return schema.parse(await response.json());
}

export function withRevision(url: string, revision: number | string) {
  const separator = url.includes("?") ? "&" : "?";
  return `${url}${separator}view=${encodeURIComponent(String(revision))}`;
}
